import { render, staticRenderFns } from "./history-section.vue?vue&type=template&id=28971558"
import script from "./history-section.vue?vue&type=script&lang=js"
export * from "./history-section.vue?vue&type=script&lang=js"
import style0 from "./history-section.vue?vue&type=style&index=0&id=28971558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports